/**
 * Hiyaku Core JavaScript
 * サイト全体で使用する共通関数
 */

(function() {
  'use strict';

  /**
   * カートの最新状態を取得してサイト全体の表示を更新
   * @returns {Promise} カートデータを返すPromise
   */
  window.refreshHiyakuCart = function() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function(response) {
      return response.json();
    })
    .then(function(cart) {
      // 1. カート数の更新（全ての要素）
      var cartCountElements = document.querySelectorAll(
        '.univ-header__cart-count, [data-cart-count], .cart-count, .cart-count-bubble, [data-cart-item-count]'
      );
      cartCountElements.forEach(function(el) {
        el.textContent = cart.item_count;
        // アニメーション効果
        el.classList.add('cart-count-updated');
        setTimeout(function() {
          el.classList.remove('cart-count-updated');
        }, 300);
      });

      // 2. Horizonテーマのカート更新イベント発火
      // Horizon標準のイベント
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      
      // Shopify標準のイベント（多くのテーマで使用）
      if (typeof window.Shopify !== 'undefined') {
        document.dispatchEvent(new CustomEvent('shopify:cart:update', { detail: cart }));
      }

      // 3. カートドロワーを開く（存在する場合）
      var cartDrawer = document.querySelector('[data-cart-drawer], .cart-drawer, #cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('is-open', 'active');
        document.body.classList.add('cart-drawer-open');
      }

      // 4. Horizonテーマ固有の処理
      if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
        // カートドロワーが存在する場合
        if (window.Shopify.theme.cartDrawer && typeof window.Shopify.theme.cartDrawer.open === 'function') {
          window.Shopify.theme.cartDrawer.open();
        }
        // カート更新関数が存在する場合
        if (typeof window.Shopify.theme.refreshCart === 'function') {
          window.Shopify.theme.refreshCart();
        }
      }

      // 5. セクションレンダリング（カートドロワーの内容更新）
      var cartDrawerSection = document.querySelector('[data-cart-drawer-section]');
      if (cartDrawerSection) {
        fetch('/?sections=cart-drawer')
          .then(function(res) { return res.json(); })
          .then(function(sections) {
            if (sections['cart-drawer']) {
              cartDrawerSection.innerHTML = sections['cart-drawer'];
            }
          })
          .catch(function(e) { console.log('Cart drawer refresh skipped'); });
      }

      console.log('[Hiyaku] Cart updated:', cart.item_count, 'items');
      return cart;
    })
    .catch(function(error) {
      console.error('[Hiyaku] Cart refresh error:', error);
      throw error;
    });
  };

  /**
   * Ajaxでカートに商品を追加
   * @param {number} variantId - バリアントID
   * @param {number} quantity - 数量（デフォルト: 1）
   * @returns {Promise} 追加結果を返すPromise
   */
  window.addToHiyakuCart = function(variantId, quantity) {
    quantity = quantity || 1;

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: parseInt(variantId, 10),
          quantity: quantity
        }]
      })
    })
    .then(function(response) {
      if (!response.ok) {
        throw new Error('Add to cart failed');
      }
      return response.json();
    })
    .then(function(data) {
      // カート更新を実行
      return window.refreshHiyakuCart().then(function() {
        return data;
      });
    });
  };

  // CSS for cart count animation
  var style = document.createElement('style');
  style.textContent = `
    @keyframes cartCountPulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.3); }
      100% { transform: scale(1); }
    }
    .cart-count-updated {
      animation: cartCountPulse 0.3s ease;
    }
  `;
  document.head.appendChild(style);

  /* ============================================
   * 閲覧履歴（Recently Viewed）機能
   * ============================================ */
  
  var RECENTLY_VIEWED_KEY = 'hiyaku_recently_viewed';
  var MAX_RECENTLY_VIEWED = 20; // 最大保存数

  /**
   * 閲覧履歴に商品を追加
   * @param {string} handle - 商品ハンドル
   */
  window.addToRecentlyViewed = function(handle) {
    if (!handle) return;
    
    try {
      var viewed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
      
      // 既に存在する場合は削除（先頭に移動するため）
      var index = viewed.indexOf(handle);
      if (index > -1) {
        viewed.splice(index, 1);
      }
      
      // 先頭に追加
      viewed.unshift(handle);
      
      // 最大数を超えた場合は古いものを削除
      if (viewed.length > MAX_RECENTLY_VIEWED) {
        viewed = viewed.slice(0, MAX_RECENTLY_VIEWED);
      }
      
      localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
      console.log('[Hiyaku] Added to recently viewed:', handle);
    } catch (e) {
      console.error('[Hiyaku] Recently viewed save error:', e);
    }
  };

  /**
   * 閲覧履歴を取得
   * @param {number} limit - 取得する最大数（デフォルト: 10）
   * @returns {Array} 商品ハンドルの配列
   */
  window.getRecentlyViewed = function(limit) {
    limit = limit || 10;
    
    try {
      var viewed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
      return viewed.slice(0, limit);
    } catch (e) {
      console.error('[Hiyaku] Recently viewed get error:', e);
      return [];
    }
  };

  /**
   * 閲覧履歴から商品データを取得
   * @param {number} limit - 取得する最大数
   * @param {string} excludeHandle - 除外する商品ハンドル（現在の商品ページ用）
   * @returns {Promise} 商品データの配列を返すPromise
   */
  window.fetchRecentlyViewedProducts = function(limit, excludeHandle) {
    limit = limit || 10;
    var handles = window.getRecentlyViewed(limit + 1); // 除外用に+1
    
    // 除外
    if (excludeHandle) {
      handles = handles.filter(function(h) { return h !== excludeHandle; });
    }
    handles = handles.slice(0, limit);
    
    if (handles.length === 0) {
      return Promise.resolve([]);
    }
    
    // 各商品のデータを取得
    var promises = handles.map(function(handle) {
      return fetch('/products/' + handle + '.json')
        .then(function(response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function(data) {
          return data ? data.product : null;
        })
        .catch(function() {
          return null;
        });
    });
    
    return Promise.all(promises).then(function(products) {
      // nullを除外して返す
      return products.filter(function(p) { return p !== null; });
    });
  };

  /**
   * 閲覧履歴をクリア
   */
  window.clearRecentlyViewed = function() {
    try {
      localStorage.removeItem(RECENTLY_VIEWED_KEY);
      console.log('[Hiyaku] Recently viewed cleared');
    } catch (e) {
      console.error('[Hiyaku] Recently viewed clear error:', e);
    }
  };

  // 商品ページで自動的に閲覧履歴に追加
  function autoSaveRecentlyViewed() {
    // Method 1: Shopify.product オブジェクトから取得
    if (typeof window.Shopify !== 'undefined' && window.Shopify.product && window.Shopify.product.handle) {
      window.addToRecentlyViewed(window.Shopify.product.handle);
      return;
    }

    // Method 2: URLパスから商品ハンドルを抽出
    var path = window.location.pathname;
    var productMatch = path.match(/\/products\/([^\/\?#]+)/);
    if (productMatch && productMatch[1]) {
      var handle = productMatch[1];
      // クエリパラメータを除去
      handle = handle.split('?')[0];
      window.addToRecentlyViewed(handle);
      console.log('[Hiyaku] Auto-saved from URL:', handle);
      return;
    }

    // Method 3: meta タグから取得
    var metaHandle = document.querySelector('meta[property="og:url"]');
    if (metaHandle) {
      var url = metaHandle.getAttribute('content');
      var urlMatch = url.match(/\/products\/([^\/\?#]+)/);
      if (urlMatch && urlMatch[1]) {
        window.addToRecentlyViewed(urlMatch[1]);
        console.log('[Hiyaku] Auto-saved from meta:', urlMatch[1]);
      }
    }
  }

  // DOMContentLoaded または即時実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoSaveRecentlyViewed);
  } else {
    autoSaveRecentlyViewed();
  }

  /* ============================================
   * カートイベントリスナー
   * ============================================ */

  /**
   * cart:update イベントをリッスンして、ヘッダーのカートアイコンを自動更新
   */
  document.addEventListener('cart:update', function(event) {
    console.log('[Hiyaku] Cart update event received');

    // refreshHiyakuCart()を呼び出してヘッダーのカートアイコンを更新
    if (typeof window.refreshHiyakuCart === 'function') {
      window.refreshHiyakuCart();
    }
  });

  console.log('[Hiyaku] Core script loaded');
  console.log('[Hiyaku] Recently viewed items:', window.getRecentlyViewed(20));
})();
